interface KairoLogoProps {
  size?: number;
  className?: string;
}

/**
 * Знак Kairo.
 *
 * Круг — сутки. Тёмный сектор — время, уже отданное сну и еде (то, что в
 * методологии выделяется первым). Яркая точка — тот самый «кайрос», момент, на
 * который назначено главное дело. Форма читается и на 16 px в favicon, и на
 * splash-экране.
 */
export function KairoLogo({ size = 40, className }: KairoLogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      className={className}
      role="img"
      aria-label="Kairo"
    >
      <defs>
        <linearGradient id="kairo-brand-gradient" x1="0" y1="0" x2="48" y2="48">
          <stop offset="0%" stopColor="var(--kairo-brand)" />
          <stop offset="100%" stopColor="var(--sphere-growth)" />
        </linearGradient>
      </defs>

      <rect width="48" height="48" rx="13" fill="url(#kairo-brand-gradient)" />

      {/* Циферблат суток */}
      <circle cx="24" cy="24" r="13" stroke="white" strokeOpacity="0.35" strokeWidth="2.5" />

      {/* Сектор режима: сон и питание, зафиксированные в расписании */}
      <path
        d="M24 11a13 13 0 0 1 11.26 19.5L24 24Z"
        fill="white"
        fillOpacity="0.9"
      />

      {/* Момент — точка, вокруг которой строится день */}
      <circle cx="24" cy="24" r="3.6" fill="white" />
    </svg>
  );
}
